import { render, staticRenderFns } from "./OrderPhoto.vue?vue&type=template&id=476bf76a&scoped=true&"
import script from "./OrderPhoto.vue?vue&type=script&lang=js&"
export * from "./OrderPhoto.vue?vue&type=script&lang=js&"
import style0 from "./OrderPhoto.vue?vue&type=style&index=0&id=476bf76a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476bf76a",
  null
  
)

export default component.exports